import { render, staticRenderFns } from "./CustomersPriceList.vue?vue&type=template&id=5116e9e9&scoped=true&"
import script from "./CustomersPriceList.vue?vue&type=script&lang=js&"
export * from "./CustomersPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116e9e9",
  null
  
)

export default component.exports